import React from 'react'
import { useNavigate } from 'react-router-dom'
import { InputGroup, Button } from '../../UI'

const SignInForm = ({ handleInput, formData, loading,address, address2, datas }) => {
  const navigate = useNavigate()

  console.log(datas)

  return (
    <>
      <InputGroup>
        <label>Orders details</label>
        <div className="orderDetail__container">
        <p>
            <span>Pick address:</span>{address}
          </p>
          <p>
            <span>Drop off address:</span>{address2}
          </p>
          <p>
            <span>Weights:</span>{formData.weights} kg
          </p>
          <p>
            <span>Total Amount:</span> {datas.amount}
          </p>
          <p>
            <span>Date:</span> 16 November 2020
          </p>
          <p>
            <span>Description:</span> {formData.description}
          </p>
        </div>
      </InputGroup>
      <Button
        full
        className="auth--btn"
       type="submit"
       loading={loading}
      >
        Proceed to make payment
      </Button>
    </>
  )
}

export default SignInForm
